import { render, staticRenderFns } from "./AltaGestionMasiva.vue?vue&type=template&id=c6b6a6ae"
import script from "./AltaGestionMasiva.vue?vue&type=script&lang=js"
export * from "./AltaGestionMasiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports